export enum RepProfileTab {
  SUMMARY,
  CALL_ACTIVITY,
  REVIEW_ACTIVITIES,
  COACHING_PLANS,
  COACHING_RECEIVED,
  CALLS,
  KPI,
}

export enum CoachingDirection {
  manager = 'manager',
  other = 'other',
  review = 'review',
  coach = 'coach',
}

export function skillsFetchParametersShared(userId, scoredBy, startDate, endDate) {
  return {
    // lgray - we widen the net for skills tab only.
    // we want to pull data prior to the beginning of the chart so
    // the lines dont look like they magically start in the middle
    from: startDate.clone().subtract(3, 'months'),
    to: endDate,
    userId,
    scorecardId: 'ALL',
    scoredOption: scoredBy,
  };
}
